import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AngularSplitModule, SplitGutterInteractionEvent } from 'angular-split';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CollabViewButtons, LIBRARY_TABS, ProjectTabs } from '../../models/enum';
import { CostSummaryViewComponent } from '../Solution/Library/cost-summary-view/cost-summary-view.component';
import { LibraryViewComponent } from '../Solution/Library/library-view/library-view.component';
import { ProjectViewTreeComponent } from '../Solution/Library/project-view-tree/project-view-tree.component';
import { NavBarService } from '../../services/nav-bar.service';
import { EstimateComponent } from "../estimate/estimate.component";
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { Subscription, take, Subject } from 'rxjs';
import { ReviewDetailComponent } from '../Common/review-detail/review-detail.component';
import { ReportsWrapperComponent } from '../reports/reports-wrapper/reports-wrapper.component';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MessageDialogComponent } from '../dialogs/common/message-dialog/message-dialog.component';
import { OpenCollaborationHubDialogComponent } from '../dialogs/common/open-collaboration-hub-dialog/open-collaboration-hub-dialog.component';
import { AccessRequestsDialogComponent } from '../dialogs/common/access-requests-dialog/access-requests-dialog.component';
import { ExportProposalRequiredFieldDialogComponent } from '../dialogs/common/export-proposal-required-field-dialog/export-proposal-required-field-dialog.component';
import { CollabDialogDataService } from '../../services/common/collab-dialog-data.service';
import { SaveConfirmationDialogComponent } from '../dialogs/common/save-confirmation-dialog/save-confirmation-dialog.component';
import { RecentAndFavEstimateComponent } from '../Common/recent-and-fav-estimate/recent-and-fav-estimate.component';
import { RecentAndFavEstimateSettingsComponent } from '../Common/recent-and-fav-estimate-settings/recent-and-fav-estimate-settings.component';
import { CONSTANTS } from '../../Constants/Constants';
import { SideNavBarComponent } from '../Common/side-nav-bar/side-nav-bar.component';
import { StatusBarComponent } from '../Common/status-bar/status-bar.component';
import { SapSubmittalPolicyViolationComponent } from '../dialogs/common/sap-submittal/sap-submittal-policy-violation/sap-submittal-policy-violation.component';
import { UnlockSubmittedEstimateDialogComponent } from '../dialogs/common/sap-submittal/unlock-submitted-estimate-dialog/unlock-submitted-estimate-dialog.component';
import { UnauthorizedAccessDialogComponent } from '../dialogs/common/unauthorized-access-dialog/unauthorized-access-dialog.component';
import { CommonDataService } from '../../services/common-data.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SearchOpportunityDialogComponent } from '../dialogs/common/search-opportunity-dialog/search-opportunity-dialog.component';
import { SolMaterialCheckerDialogComponent } from '../dialogs/sol/sol-material-checker-dialog/sol-material-checker-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  FetchMode, GetUserPreferencesResponse,
  ProjectViewLastLayout,
  MetaDataRequest,
  MetaDataResponse,
  UserNotificationItem,
  ApplicationLastLayout,
  LeftPanel,
  ApplicationLayout,
  GetUserDataRequest,
  GetUserDataResponse,
  SetUserDataRequest,
  CollaborationState,
  AccessRequestModel,
  EmailBase
} from '../../models/dtos';
import { ActivatedRoute } from '@angular/router';
import { UserDataApiService } from '../../services/api/user-data.service';
import { OpenEstimateApiService } from '../../services/api/open-estimate.service';
import { CommonMetaDataService } from '../../services/common-meta-data.service';
import { ApiPollingService } from '../../services/common/api-polling.service';
import { ProjectViewPanel } from '../../models/common/PreferanceResponse';
import { NotificationMessageService } from '../../services/common/notification-message.service';
import { UserProfileService } from '../../services/common/user-profile.service';
import { CommonFunctionsService } from '../../services/common-functions.service';
import { EstimateCloseService } from '../../services/estimate-close.service';
import { EstimateSaveService } from '../../services/estimate-save.service';
import { CollaborationOperationsService } from '../../services/common/collaboration-operations.service';
import { SyncOperationsService } from '../../services/common/sync-operations.service';
import { IAccessRequestsDialogData } from '../../models/collaboration/IAccessRequestsDialogData';
import { StaticDropdownService } from '../../services/common/static-dropdown.service';
import { UnsavedChangesService } from '../../services/common/unsaved-changes.service';

@Component({
  selector: 'app-dashboard',
  imports: [
    MatTabsModule,
    TranslatePipe,
    AngularSplitModule,
    CommonModule,
    MatCardModule,
    MatIconModule,
    EstimateComponent,
    ProjectViewTreeComponent,
    CostSummaryViewComponent,
    LibraryViewComponent,
    MatDialogModule,
    MatExpansionModule,
    MatButtonModule,
    MatMenuModule,
    ReportsWrapperComponent,
    ReviewDetailComponent,
    SideNavBarComponent,
    StatusBarComponent,
    FormsModule,
    MatTooltipModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: true
})
export class DashboardComponent implements OnInit, OnDestroy {
  projectTabs = ProjectTabs;
  selectedTabIndex: number = this.projectTabs.Estimate;
  lastSelectedTabIndex: number = this.projectTabs.Estimate;
  leftSideSize: number = CONSTANTS.SPLIT_LIBRARY_WIDTH;
  centerSize: number = CONSTANTS.SPLIT_WORKSPACE_WIDTH;
  rightSideSize: number = CONSTANTS.SPLIT_LIBRARY_WIDTH;
  previewPanelHeight: number = 0;
  projectViewPanelHeight: number = 100;
  isProjectViewVisible: boolean = true;
  isCostSummaryVisible: boolean = true;
  isLibraryVisible: boolean = true;
  isReportViewVisible: boolean = true;
  isPreviewViewVisible: boolean = false;
  dialogPosition: { top: string } = { top: '75px' };
  dialogWidth: string = '800px';
  panelOpenState: boolean = false;
  isReportContentVisible: boolean = true;
  dialogHeight: string = '380px';
  selectedTab = 0;
  emptyString: string = CONSTANTS.EMPTY_STRING;

  public SOLUTION_LIBRARY_ITEMS = LIBRARY_TABS;
  readOnlyMode: boolean = false;
  destroy$: Subject<void> = new Subject<void>();
  public COLLAB_ITEMS = CollabViewButtons;
  isPublished: boolean = false;
  private collabSub?: Subscription;
  preferenceData: GetUserPreferencesResponse = null;
  userData: GetUserDataResponse = null;
  estimateId: string = CONSTANTS.DEFAULT_ESTIMATE_ID;
  showEstimateId: boolean = true;
  estimateName: string = CONSTANTS.EMPTY_STRING;

  @ViewChild('accessPanel', { static: false }) accessPanel: MatExpansionPanel;
  @ViewChild(MatMenuTrigger) syncMenuTrigger!: MatMenuTrigger;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  // Visual index we forced the tab group back to after a cancelled switch; its change event must be ignored.
  private tabRevertIndex: number | null = null;
  isReviewTabVisible: boolean = true;
  isCopied: boolean = false;
  isEstimateDataVisible: boolean = true;
  // Hidden until getMetaData confirms the user is authorized to use SiQuote Web.
  isAuthorized: boolean = false;
  newMessages: boolean = false;
  allMessagesDeleted: boolean = false;
  accessRequests: AccessRequestModel[] = [];
  rightPanelWidth: number = 0;
  leftPanelWidth: number = 0;
  projectViewLayout: ProjectViewLastLayout = null;
  projectViewPanelDetails: ProjectViewPanel = null;
  isSideNavOpen: boolean = false;
  isSapSubmitted: boolean = false;
  private skipCloseSideNavOnNextTabChange: boolean = false;
  private displayedTabs = [this.projectTabs.Estimate, this.projectTabs.Review, this.projectTabs.Reports];
  private _publishBeforeCloseDialogOpen = false;
  private readonly _beforeUnloadHandler = (event: BeforeUnloadEvent): string | undefined => {
    if (this._publishBeforeCloseDialogOpen) return undefined;
    if (this.commonDataService.getCollaborationState() === CollaborationState.Edit) {
      event.preventDefault();
      event.returnValue = ''; // triggers native "Leave site?" dialog in Chrome/Edge/Firefox
      setTimeout(() => this.openPublishBeforeCloseBrowserDialog(), 0);
      return ''; // required for older browsers (Safari, legacy Edge)
    }
    if ((this.commonDataService.isSaveEnabled && !this.commonDataService.isReadOnlyMode())
      || this.unsavedChangesService.hasUnsavedChanges()) {
      event.preventDefault();
      event.returnValue = ''; // triggers native "Leave site?" dialog in Chrome/Edge/Firefox
      return ''; // required for older browsers (Safari, legacy Edge)
    }
    return undefined;
  };

  // Sync status GIF paths
  private readonly YELLOW_SERVER_GIF = 'assets/images/Yellow-Server-2.gif';
  private readonly GREEN_SERVER_GIF = 'assets/images/Green-Server-2.gif';
  private readonly RED_SERVER_GIF = 'assets/images/Red-Server-2.gif';
  syncStatusGifPath: string = this.RED_SERVER_GIF;
  syncStatusTooltip: string = '';
  CollaborationState = CollaborationState;

  constructor(
    public readonly navBarService: NavBarService,
    public readonly dialog: MatDialog,
    private readonly commonDataService: CommonDataService,
    private readonly collabDialogDataService: CollabDialogDataService,
    private readonly route: ActivatedRoute,
    private readonly userDataApiService: UserDataApiService,
    private readonly apiPollingService: ApiPollingService,
    private notificationMessageService: NotificationMessageService,
    private readonly openEstimateApiService: OpenEstimateApiService,
    private readonly commonMetaDataService: CommonMetaDataService,
    private readonly translate: TranslateService,
    private readonly userProfileService: UserProfileService,
    private readonly commonFunctionsService: CommonFunctionsService,
    private readonly estimateSaveService: EstimateSaveService,
    private readonly estimateCloseOperationsService: EstimateCloseService,
    private readonly collaborationOperationsService: CollaborationOperationsService,
    private readonly syncOperationsService: SyncOperationsService,
    private readonly staticDropdownService: StaticDropdownService,
    private readonly unsavedChangesService: UnsavedChangesService
  ) { }


  ngOnInit() {
    this.preferenceData = this.route.snapshot.data['preferences'];
    this.commonDataService.setPreferenceData(this.preferenceData);
    this.isReviewTabVisible = this.commonDataService.getReviewTabVisibility();
    this.configureApplicationWithCulture();
    this.getMetaData();
    this.fetchUserData();
    this.subscribeEstimateData();
    this.subscribeReviewTabVisibility();
    this.subscribeCollaborationPublished();
    this.checkReadOnlyMode();
    this.startNotificationPolling();
    this.collaborationOperationsService.startCollaborationPolling();
    this.subscribeAccessRequests();
    this.getValueOfIsSyncNeededFlag();
    this.staticDropdownService.loadData();
    window.addEventListener('beforeunload', this._beforeUnloadHandler);

    this.subscribeSapSubmitted();
    this.subscribeLeftPanelWidth();
    this.subscribeEstimateTabNavigation();
  }

  private subscribeCollaborationPublished(): void {
    this.collabSub = this.collabDialogDataService.isPublished$
      .pipe(takeUntil(this.destroy$))
      .subscribe(p => this.isPublished = p);
  }

  private subscribeAccessRequests(): void {
    this.commonDataService.accessRequests$
      .pipe(takeUntil(this.destroy$))
      .subscribe(accessRequests => {
        this.accessRequests = accessRequests;
      });
  }

  private subscribeSapSubmitted(): void {
    this.commonDataService.isSapSubmitted$.pipe(takeUntil(this.destroy$)).subscribe(isSapSubmitted => {
      this.isSapSubmitted = isSapSubmitted;
    });
  }

  private subscribeLeftPanelWidth(): void {
    this.commonDataService.leftPanelWidth$.pipe(takeUntil(this.destroy$)).subscribe(width => {
      this.leftPanelWidth = width;
      this.updateSplits();
    });
  }

  private subscribeEstimateTabNavigation(): void {
    // Root-scoped signal so an in-flight OpenEstimate call can switch tabs
    // even if its host component (e.g. inline <open-estimate>) was destroyed.
    this.commonDataService.navigateToEstimateTabRequested$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.navigateToEstimateTab());
  }

  private fetchUserData() {
    const userDataRequest: GetUserDataRequest = {
      userId: this.userProfileService.userInfo?.gid ?? CONSTANTS.EMPTY_STRING,
      getApplicationLayoutObject: FetchMode.Server,
      getMultiPdfLocalLibraryReportsObject: true
    };
    this.userDataApiService.getUserData(userDataRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: GetUserDataResponse) => {
        this.userData = response;
        this.commonDataService.setUserData(response);
        if (this.userData?.applicationLayout) {
          this.projectViewLayout = this.userData.applicationLayout?.projectViewLastLayout;
          this.projectViewPanelHeight = this.userData.applicationLayout.applicationLastLayout?.leftPanel.projectViewPanelHeight;
          this.previewPanelHeight = CONSTANTS.SPLIT_FULL_WIDTH - this.projectViewPanelHeight;
          this.selectedTabIndex = this.userData.applicationLayout.applicationLastLayout?.lastActiveTab >= 0 ? this.userData.applicationLayout.applicationLastLayout?.lastActiveTab : this.projectTabs.Estimate;
          this.selectedTabIndex = this.projectTabs.Estimate;// TO-DO: for Phase1, Estimate tab will be dafult active tab. LastActiveTab will be used in next Phase.
          this.lastSelectedTabIndex = this.selectedTabIndex;
          this.projectViewAutoHideOrHide();
          this.assignSplitAreaWidths();
        }
      });
  }

  private configureApplicationWithCulture() {
    if (!this.preferenceData || !this.preferenceData.preferences) {
      return;
    }
    const cultureString = this.preferenceData.preferences.cultureString || 'en-US';
    this.translate.setDefaultLang(cultureString);
    this.translate.use(cultureString);
  }

  private startNotificationPolling() {
    this.apiPollingService.getNotificationsMessages()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (hasNewMessages: boolean) => {
          this.newMessages = hasNewMessages;
          if (!hasNewMessages) {
            const notifications = this.commonDataService.getNotifications();
            this.checkAllMessagesDeleted(notifications);
            this.checkAllMessagesRead(notifications);
          }
        },
        error: () => {
          console.error('Error while polling for notifications'); //TO-DO: need to add proper error handling
        }
      });
  }

  private getValueOfIsSyncNeededFlag(): void {
    this.commonDataService.isSyncNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (isSyncNeeded: boolean) => {
          if (isSyncNeeded) {
            this.syncStatusGifPath = this.RED_SERVER_GIF;
            this.syncStatusTooltip = this.translate.instant('SYNC_STATUS.SYNC_REQUIRED');
          } else {
            this.syncStatusGifPath = this.GREEN_SERVER_GIF;
            this.syncStatusTooltip = this.translate.instant('SYNC_STATUS.DATA_UP_TO_DATE');
          }
        },
        error: () => {
          this.syncStatusGifPath = this.YELLOW_SERVER_GIF;
          this.syncStatusTooltip = this.translate.instant('SYNC_STATUS.SYNC_ERROR');
          console.error(this.translate.instant('SYNC.FLAG_SUBSCRIPTION_ERROR')); //TO-DO: need to add proper error handling
        }
      });
  }

  private checkAllMessagesRead(notifications: UserNotificationItem[]) {
    if (notifications && notifications.length) {
      const nonReadStatuses = notifications.filter(status => !status.isRead);
      this.newMessages = nonReadStatuses.length > 0;
    }
  }

  private checkAllMessagesDeleted(notifications: UserNotificationItem[]) {
    const activeNotifications = notifications ?? [];
    this.allMessagesDeleted = activeNotifications?.length === 0;
  }

  private getMetaData() {
    const cultureString = this.preferenceData?.preferences?.cultureString || 'en-US';
    const cultureId = cultureString ? this.commonFunctionsService.getCultureId(cultureString) : 1;
    const request: MetaDataRequest = {
      cultureId: cultureId,
    };
    this.openEstimateApiService.getMetaData(request)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: MetaDataResponse) => {
          if (response && response.userProfile?.canUseSQWeb) {
            this.commonMetaDataService.setMetaData(response);
            this.isAuthorized = true;
          }
          else {
            console.error('User not authorised to use SiQuote Web');
            this.isAuthorized = false;
            this.openUnauthorizedAccessDialog();
          }
        },
        error: (error: any) => {
          console.error('Error fetching metadata:', error);
          this.commonFunctionsService.logout();
        }
      });
  }

  private openUnauthorizedAccessDialog(): void {
    this.dialog.open(UnauthorizedAccessDialogComponent, {
      width: '400px',
      disableClose: true
    });
  }

  private subscribeEstimateData(): void {
    this.commonDataService.estimateDataChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((estimateData) => {
        if (estimateData) {
          this.loadEstimateId();
        } else {
          this.estimateId = CONSTANTS.DEFAULT_ESTIMATE_ID;
          this.estimateName = CONSTANTS.EMPTY_STRING;
        }
      });
  }

  private subscribeReviewTabVisibility(): void {
    this.commonDataService.isReviewTabVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (isVisible: boolean) => {
          this.isReviewTabVisible = isVisible;

          if (!isVisible && this.selectedTabIndex === this.projectTabs.Review) {
            this.selectedTabIndex = this.projectTabs.Estimate;
            this.updateSplits();
          }
        },
        error: (error: any) => {
          console.error('Error subscribing to review tab visibility:', error);
        }
      });
  }


  private projectViewAutoHideOrHide() {
    if (this.userData?.applicationLayout?.applicationLastLayout) {
      const projectViewPanel = this.userData.applicationLayout.applicationLastLayout.projectViewPanel;
      this.isProjectViewVisible = !projectViewPanel.autoHide;
      this.isReportViewVisible = !projectViewPanel.autoHide;
      this.navBarService.isProjectViewClosed = projectViewPanel.hide;
      this.navBarService.isReportViewClosed = projectViewPanel.hide;
    }
  }

  private assignSplitAreaWidths() {
    if (this.userData?.applicationLayout?.applicationLastLayout?.leftPanel) {
      const width = this.userData.applicationLayout.applicationLastLayout.leftPanel.width || CONSTANTS.SPLIT_LIBRARY_WIDTH;
      this.commonDataService.setLeftPanelWidth(width);
      this.rightPanelWidth = 0; //TO-DO: right panel is not part of phase 1, set to 0 for now
      this.updateSplits();
    }
  }

  private checkReadOnlyMode() {
    this.commonDataService.readOnlyMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe(disabled => {
        this.readOnlyMode = disabled;
      });
  }

  get isReportsTab(): boolean { return this.selectedTabIndex === this.projectTabs.Reports; }
  get isReviewTab(): boolean { return this.selectedTabIndex === this.projectTabs.Review; }
  get isEstimateTab(): boolean { return this.selectedTabIndex === this.projectTabs.Estimate; }

  get showProjectViewArea(): boolean {
    return ((this.isProjectViewVisible
      && !this.navBarService.isProjectViewClosed)
      || (this.isPreviewViewVisible
        && !this.navBarService.isPreviewViewClosed))
      && !this.isReportsTab
      && !this.isReviewTab;
  }

  get showProjectViewCollapsedTag(): boolean {
    return !this.isProjectViewVisible
      && !this.navBarService.isProjectViewClosed
      && !this.isReportsTab
      && !this.isReviewTab;
  }

  get showPreviewCollapsedTag(): boolean {
    return !this.isPreviewViewVisible
      && !this.navBarService.isPreviewViewClosed
      && !this.isReportsTab
      && !this.isReviewTab;
  }

  get showReportViewArea(): boolean {
    return this.isReportsTab
      && this.isReportViewVisible
      && !this.navBarService.isReportViewClosed;
  }

  get showReportViewCollapsedTag(): boolean {
    return this.isReportsTab
      && !this.isReportViewVisible;
  }

  get showRightLibraries(): boolean {
    const anyRightOpen =
      (this.isCostSummaryVisible && !this.navBarService.isCostSummaryClosed) ||
      (this.isLibraryVisible && !this.navBarService.isLibraryClosed);
    return anyRightOpen
      && !this.isEstimateTab
      && !this.isReviewTab
      && !this.isReportsTab;
  }

  get showRightCollapsedTags(): boolean {
    const anyRightNotPinned =
      (!this.isCostSummaryVisible && !this.navBarService.isCostSummaryClosed) ||
      (!this.isLibraryVisible && !this.navBarService.isLibraryClosed);
    return anyRightNotPinned
      && !this.isEstimateTab
      && !this.isReportsTab
      && !this.isReviewTab;
  }

  get safeLeftSize(): number {
    return this.showProjectViewArea ? this.leftSideSize : 0;
  }

  get safeRightSize(): number {
    return this.showRightLibraries ? this.rightSideSize : 0;
  }

  get safeCenterSize(): number {
    return Math.max(0, CONSTANTS.SPLIT_FULL_WIDTH - this.safeLeftSize - this.safeRightSize);
  }


  toggleSideNav(): void {
    this.isSideNavOpen = !this.isSideNavOpen;
  }

  closeSideNav(): void {
    this.isSideNavOpen = false;
  }

  /** User-initiated close: asks first when Properties/Preferences hold unsaved edits. */
  async requestCloseSideNav(): Promise<void> {
    if (await this.unsavedChangesService.confirmLeave()) {
      this.closeSideNav();
    }
  }

  navigateToEstimateTab(): void {
    this.closeSideNav();
    this.navigateToEstimateTabInternal();
  }

  navigateToEstimateTabWithoutClosingSideNav(): void {
    this.skipCloseSideNavOnNextTabChange = this.selectedTabIndex !== this.projectTabs.Estimate;
    this.navigateToEstimateTabInternal();
  }

  private navigateToEstimateTabInternal(): void {
    this.selectedTabIndex = this.projectTabs.Estimate;
    this.commonDataService.setActiveTab(this.selectedTabIndex);
    this.updateSplits();
  }

  setDefaultEstimateId(): void {
    this.estimateId = CONSTANTS.DEFAULT_ESTIMATE_ID;
    this.estimateName = CONSTANTS.EMPTY_STRING;
  }

  async onTabChange(event: MatTabChangeEvent): Promise<void> {
    if (this.tabRevertIndex === event.index) {
      this.tabRevertIndex = null;
      return;
    }

    // Programmatic switches already updated selectedTabIndex, so only user-driven ones are checked.
    const isTabSwitch = this.displayedTabs[event.index] !== this.selectedTabIndex;
    if (isTabSwitch && !await this.unsavedChangesService.confirmLeave()) {
      // Material has no veto hook, so put the tab group back on the tab the user is still on.
      this.tabRevertIndex = this.selectedVisualTabIndex;
      this.tabGroup.selectedIndex = this.tabRevertIndex;
      return;
    }

    if (this.skipCloseSideNavOnNextTabChange) {
      this.skipCloseSideNavOnNextTabChange = false;
    } else {
      this.closeSideNav();
    }
    this.selectedTabIndex = this.displayedTabs[event.index];
    if (!this.isReviewTabVisible && this.selectedTabIndex === this.projectTabs.Review) {
      this.selectedTabIndex = this.projectTabs.Reports;
    }
    this.commonDataService.setActiveTab(this.selectedTabIndex);
    this.updateSplits();
  }

  updateSplits() {
    switch (this.selectedTabIndex) {
      case this.projectTabs.Reports:
        this.leftSideSize = this.leftPanelWidth;
        this.centerSize = CONSTANTS.SPLIT_FULL_WIDTH - this.leftPanelWidth;
        this.rightSideSize = CONSTANTS.SPLIT_NO_WIDTH;
        break;
      case this.projectTabs.Review:
        this.leftSideSize = CONSTANTS.SPLIT_NO_WIDTH;
        this.centerSize = CONSTANTS.SPLIT_FULL_WIDTH;
        this.rightSideSize = CONSTANTS.SPLIT_NO_WIDTH;
        break;
      case this.projectTabs.Estimate:
        this.leftSideSize = this.leftPanelWidth;
        this.centerSize = CONSTANTS.SPLIT_FULL_WIDTH - this.leftPanelWidth;
        this.rightSideSize = CONSTANTS.SPLIT_NO_WIDTH;
        break;
      default:
        this.leftSideSize = this.leftPanelWidth;
        this.centerSize = CONSTANTS.SPLIT_FULL_WIDTH - this.leftPanelWidth - this.rightPanelWidth;
        this.rightSideSize = this.rightPanelWidth;
        break;
    }
  }

  calculateSplitWidth() {
    if (this.selectedTabIndex !== this.projectTabs.Reports) {
      if ((!this.isProjectViewVisible || this.navBarService.isProjectViewClosed) && (!this.isPreviewViewVisible || this.navBarService.isPreviewViewClosed)) {
        this.centerSize += this.leftPanelWidth;
      }
      else if ((!this.isCostSummaryVisible || this.navBarService.isCostSummaryClosed) && (!this.isLibraryVisible || this.navBarService.isLibraryClosed)) {
        this.centerSize += this.rightPanelWidth;
      }
    }
  }

  openLibrary(library: LIBRARY_TABS) {
    switch (library) {
      case this.SOLUTION_LIBRARY_ITEMS.Preview:
        this.isPreviewViewVisible = true;
        this.navBarService.isPreviewViewClosed = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ProjectView:
        this.isProjectViewVisible = true;
        this.isReportViewVisible = true;
        this.navBarService.isProjectViewClosed = false;
        this.navBarService.isReportViewClosed = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.CostSummaryView:
        this.isCostSummaryVisible = true;
        this.navBarService.isCostSummaryClosed = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.LibraryView:
        this.isLibraryVisible = true;
        this.navBarService.isLibraryClosed = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ReportView:
        this.isReportViewVisible = true;
        this.isProjectViewVisible = true;
        this.navBarService.isProjectViewClosed = false;
        this.navBarService.isReportViewClosed = false;
        break;
      default:
        break;
    }
    this.updateSplits();
  }

  unpinLibrary(library: LIBRARY_TABS) {
    switch (library) {
      case this.SOLUTION_LIBRARY_ITEMS.Preview:
        this.isPreviewViewVisible = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ProjectView:
        this.isProjectViewVisible = false;
        this.isReportViewVisible = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.CostSummaryView:
        this.isCostSummaryVisible = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.LibraryView:
        this.isLibraryVisible = false;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ReportView:
        this.isReportViewVisible = false;
        this.isProjectViewVisible = false;
        break;
      default:
        break;
    }
    this.calculateSplitWidth();
  }

  closeLibrary(library: LIBRARY_TABS) {
    switch (library) {
      case this.SOLUTION_LIBRARY_ITEMS.Preview:
        this.navBarService.isPreviewViewClosed = true;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ProjectView:
        this.navBarService.isProjectViewClosed = true;
        this.navBarService.isReportViewClosed = true;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ReportView:
        this.navBarService.isReportViewClosed = true;
        this.navBarService.isProjectViewClosed = true;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.CostSummaryView:
        this.navBarService.isCostSummaryClosed = true;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.LibraryView:
        this.navBarService.isLibraryClosed = true;
        break;
      default:
        break;
    }
    this.calculateSplitWidth();
  }

  closeEstimate() {
    const ref = this.dialog.open(SaveConfirmationDialogComponent, {
      data: { estimateId: this.commonDataService.getEstimateId() },
      disableClose: true
    });
    ref.afterClosed()
      .pipe(take(CONSTANTS.ONE))
      .subscribe(async result => {
        if (result?.hideEstimateData) {
          // Reset all estimate-scoped service state
          await this.estimateCloseOperationsService.closeEstimate();

          this.isEstimateDataVisible = false;
          this.estimateId = CONSTANTS.EMPTY_STRING;
          this.estimateName = CONSTANTS.EMPTY_STRING;
        }
        this.isReportViewVisible = true;
        this.navBarService.isProjectViewClosed = false;
        this.navBarService.isReportViewClosed = false;
        this.isReportContentVisible = false;

      });
  }

  // ─── Browser tab/window close interception ──────────────────────────────────
  // NOTE: beforeunload is registered via window.addEventListener in ngOnInit
  // (more reliable than @HostListener for this specific event).
  // The handler is in _beforeUnloadHandler above.

  /**
   * Opens the Angular dialog after the user clicked "Stay" on the native dialog.
   * The user must explicitly choose Publish, Discard, or Cancel — no auto-close path.
   */
  private async openPublishBeforeCloseBrowserDialog(): Promise<void> {
    if (this._publishBeforeCloseDialogOpen) return;
    this._publishBeforeCloseDialogOpen = true;
    let canClose = false;
    try {
      canClose = await this.estimateCloseOperationsService.collaborativeChecksBeforeClose(
        () => this.estimateSaveService.createSaveEstimateRequest());
    } finally {
      this._publishBeforeCloseDialogOpen = false;
    }
    if (!canClose) {
      return;
    }
    await this.estimateCloseOperationsService.closeEstimate();
    this.isEstimateDataVisible = false;
    this.estimateId = CONSTANTS.EMPTY_STRING;
    this.estimateName = CONSTANTS.EMPTY_STRING;
    this.isReportViewVisible = true;
    this.navBarService.isProjectViewClosed = false;
    this.navBarService.isReportViewClosed = false;
    this.isReportContentVisible = false;
  }

  openMailDialog() {
    // If there are no notification, then the notification dialog should not open
    const notifications = this.commonDataService.getNotifications() ?? [];
    if (!notifications.length) {
      this.allMessagesDeleted = true;
      this.newMessages = false;
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { ...this.dialogPosition };
    dialogConfig.width = this.dialogWidth;
    dialogConfig.height = this.dialogHeight;
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(MessageDialogComponent, dialogConfig);
    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const notifications = this.commonDataService.getNotifications();
        this.checkAllMessagesDeleted(notifications);
        this.checkAllMessagesRead(notifications);
      });
  }

  openCollaborationDialog() {

    const ref = this.dialog.open(OpenCollaborationHubDialogComponent, {
      width: this.dialogWidth,
      height: this.dialogHeight,
      position: { ...this.dialogPosition },
      autoFocus: false,
      disableClose: true,
      data: {
        collaborationHistory: this.commonDataService.getCollaborationHistory()
      }
    });
  }

  discardChanges() {
    this.collabDialogDataService.discardCollabChanges();
  }

  publishChanges() {
    this.collabDialogDataService.openPublishDialog();
  }

  onAccessAction(action: string) {
    switch (action) {
      case this.COLLAB_ITEMS.acceptDiscard:
        this.discardChanges();
        break;
      case this.COLLAB_ITEMS.acceptPublish:
        this.publishChanges();
        break;
      default:
        break;
    }
    this.hideAccessRequestPanel();
  }

  hideAccessRequestPanel() {
    if (this.accessPanel) {
      this.accessPanel.close();
    }
    this.panelOpenState = false;
  }
  openExportProposalLinkedDialog() {
    this.dialog.open(ExportProposalRequiredFieldDialogComponent, { width: '450px', });
  }

  openSapSubmittalDialog() {
    this.dialog.open(SapSubmittalPolicyViolationComponent, { width: '800px', });
  }

  unlockSubmittedEstimate() {
    this.dialog.open(UnlockSubmittedEstimateDialogComponent, { height: '300px', disableClose: true, });
  }
  //README: This method is only added to show the popup until tools menu items are not integrated, therefore please ignore
  openMaterialChecker() {
    this.dialog.open(SolMaterialCheckerDialogComponent, {
      width: '600px',
      height: '345px',
      disableClose: true,
    });
  }

  openSearchOpportunityDialog() {
    this.dialog.open(SearchOpportunityDialogComponent, {
      width: '700px'
    })
  }

  openRecentEstimatesDialog() {
    this.dialog.open(RecentAndFavEstimateComponent, { width: '400px', });
  }

  openRecentEstimatesSettingDialog() {
    this.dialog.open(RecentAndFavEstimateSettingsComponent, { width: '450px', });
  }


  getEstimateId(): string {
    return this.commonDataService.getEstimateId();
  }

  private loadEstimateId(): void {
    const currentProjectGuid = this.commonDataService.getEstimateId();
    const estimateName = this.commonDataService.getEstimateData()?.estimateName;
    if (currentProjectGuid) {
      this.estimateId = currentProjectGuid;
    }
    if (estimateName) {
      this.estimateName = estimateName;
    }
  }

  toggleEstimateDisplay(): void {
    this.showEstimateId = !this.showEstimateId;
  }

  copyEstimateId(): void {
    const textToCopy = this.showEstimateId ? this.estimateId : this.estimateName;
    if (!textToCopy) {
      return;
    }
    navigator.clipboard.writeText(textToCopy);
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 1000);
  }


  dragEndSplittedArea(event: SplitGutterInteractionEvent) {
    const newWidth = Math.round(Number(event.sizes[0]))
    this.commonDataService.setLeftPanelWidth(newWidth);
  }

  saveCurrentWorkspace() {

    if (!this.userData) {
      return;
    }

    if (!this.userData.applicationLayout) {
      this.userData.applicationLayout = new ApplicationLayout();
      this.userData.applicationLayout.applicationLastLayout = new ApplicationLastLayout();
      this.userData.applicationLayout.projectViewLastLayout = new ProjectViewLastLayout();
      this.userData.applicationLayout.applicationLastLayout.leftPanel = new LeftPanel();
      this.userData.applicationLayout.applicationLastLayout.projectViewPanel = new ProjectViewPanel();
    }

    const workspacerequest = new SetUserDataRequest();
    workspacerequest.userId = this.userProfileService.userInfo?.gid || CONSTANTS.EMPTY_STRING;
    workspacerequest.applicationLayout = this.userData.applicationLayout;
    const applicationLayout = workspacerequest.applicationLayout;
    applicationLayout.applicationLastLayout = this.userData.applicationLayout.applicationLastLayout;
    applicationLayout.projectViewLastLayout = this.userData.applicationLayout.projectViewLastLayout;
    applicationLayout.applicationLastLayout.leftPanel.width = this.leftSideSize;
    applicationLayout.applicationLastLayout.leftPanel.projectViewPanelHeight = this.projectViewPanelHeight;
    applicationLayout.applicationLastLayout.lastActiveTab = this.selectedTabIndex;
    applicationLayout.applicationLastLayout.projectViewPanel.autoHide = !this.isProjectViewVisible;
    applicationLayout.applicationLastLayout.projectViewPanel.hide = this.navBarService.isProjectViewClosed;
    applicationLayout.projectViewLastLayout.projectViewTemplate = this.projectViewLayout?.projectViewTemplate || 40;
    this.saveCurrentworkspaceAPICall(workspacerequest);
  }


  saveCurrentworkspaceAPICall(userDataRequest: SetUserDataRequest) {
    this.closeSideNav();
    this.userDataApiService.setUserData(userDataRequest).pipe(
      take(1)
    ).subscribe({
      next: (response: boolean) => {
        if (response) {
          this.notificationMessageService.showNotificationMessageDialog(CONSTANTS.TYPE_SUCCESS, CONSTANTS.SUCCESS_TITLE, "Application Layout saved successfully", CONSTANTS.DEFAULT_DIALOG_WIDTH);
        }
      },
      error: () => {
        console.error('Error saving application layout');
      }
    });
  }

  resetCurrentWorkspace() {
    const request: GetUserDataRequest = {
      userId: this.userProfileService.userInfo?.gid || CONSTANTS.EMPTY_STRING,
      getApplicationLayoutObject: FetchMode.Server,
      getMultiPdfLocalLibraryReportsObject: false
    };
    this.closeSideNav();
    this.userDataApiService.getUserData(request).pipe(
      take(1)
    ).subscribe({
      next: (response: GetUserDataResponse) => {
        this.prefillingApplicationLayoutAndProjectViewLayout(response);
      },
      error: () => {
        console.error('Error resetting application layout');
      }
    });
  }

  resetFactoryWorkspace() {
    const request: GetUserDataRequest = {
      userId: this.userProfileService.userInfo?.gid || CONSTANTS.EMPTY_STRING,
      getApplicationLayoutObject: FetchMode.Default,
      getMultiPdfLocalLibraryReportsObject: false
    };
    this.closeSideNav();
    this.userDataApiService.getUserData(request).pipe(
      take(1)
    ).subscribe({
      next: (response: GetUserDataResponse) => {
        this.prefillingApplicationLayoutAndProjectViewLayout(response);
        this.notificationMessageService.showNotificationMessageDialog(CONSTANTS.TYPE_SUCCESS, CONSTANTS.SUCCESS_TITLE, "Application Layout reset to factory settings", CONSTANTS.DEFAULT_DIALOG_WIDTH);
      },
      error: () => {
        console.error('Error resetting application layout to factory settings');
      }
    });
  }

  prefillingApplicationLayoutAndProjectViewLayout(response: GetUserDataResponse) {
    this.userData = response;
    const applicationLayout = this.userData.applicationLayout;
    if (applicationLayout) {
      this.projectViewLayout = applicationLayout.projectViewLastLayout || null;
      this.projectViewPanelHeight = applicationLayout.applicationLastLayout?.leftPanel?.projectViewPanelHeight || 50;
      this.previewPanelHeight = CONSTANTS.SPLIT_FULL_WIDTH - this.projectViewPanelHeight;

      this.projectViewAutoHideOrHide();
    }
    this.assignSplitAreaWidths();
    this.updateSplits();
  }

  toggleLibrary(library: LIBRARY_TABS) {
    switch (library) {
      case this.SOLUTION_LIBRARY_ITEMS.Preview:
        if (this.navBarService.isPreviewViewClosed) {
          this.isPreviewViewVisible = true;
          this.navBarService.isPreviewViewClosed = false;
        } else {
          this.navBarService.isPreviewViewClosed = true;
        }
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ProjectView:
      case this.SOLUTION_LIBRARY_ITEMS.ReportView:
        if (this.navBarService.isProjectViewClosed) {
          this.isProjectViewVisible = true;
          this.isReportViewVisible = true;
          this.navBarService.isProjectViewClosed = false;
          this.navBarService.isReportViewClosed = false;
        } else {
          this.navBarService.isProjectViewClosed = true;
          this.navBarService.isReportViewClosed = true;
        }
        break;
      case this.SOLUTION_LIBRARY_ITEMS.CostSummaryView:
        if (this.navBarService.isCostSummaryClosed) {
          this.isCostSummaryVisible = true;
          this.navBarService.isCostSummaryClosed = false;
        } else {
          this.navBarService.isCostSummaryClosed = true;
        }
        break;
      case this.SOLUTION_LIBRARY_ITEMS.LibraryView:
        if (this.navBarService.isLibraryClosed) {
          this.isLibraryVisible = true;
          this.navBarService.isLibraryClosed = false;
        } else {
          this.navBarService.isLibraryClosed = true;
        }
        break;
    }
    this.updateSplits();
  }

  closeDrawer() {
    const tempSelectedTabIndex = this.selectedTabIndex;
    this.selectedTabIndex = this.lastSelectedTabIndex;
    this.lastSelectedTabIndex = tempSelectedTabIndex;
    this.updateSplits();
  }

  getCollaborationState(): CollaborationState {
    return this.commonDataService.getCollaborationState();
  }

  isCollaborationEstimateOpen(): boolean {
    const collaborationState = this.getCollaborationState();
    return collaborationState !== CollaborationState.NonCollaborative;
  }

  openAccessRequests() {
    const data: IAccessRequestsDialogData = { accessRequests: this.accessRequests };
    this.dialog.open(AccessRequestsDialogComponent, {
      width: '800px',
      height: '300px',
      position: { ...this.dialogPosition },
      autoFocus: false,
      disableClose: true,
      data
    }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result?.action === 'decline' || result?.action === 'acceptPublish' || result?.action === 'acceptDiscard') {
          this.commonDataService.setAccessRequests([]);
        }
      });
  }

  get selectedVisualTabIndex(): number {
    return this.displayedTabs.indexOf(this.selectedTabIndex);
  }
  openSyncMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.syncMenuTrigger.openMenu();
  }

  getSyncData(): void {
    this.syncOperationsService.synchronizeData();
  }

  get isReReviewNeeded(): boolean {
    return this.commonDataService.getIsReviewCancelledBySystem;
  }


  ngOnDestroy(): void {
    this.isCopied = false;
    this.collabSub?.unsubscribe();
    this.destroy$.next(undefined);
    this.destroy$.complete();
    window.removeEventListener('beforeunload', this._beforeUnloadHandler);
  }
}
